module.exports = __webpack_public_path__ + "img/seo-audit.db6dfea3.png";